<template>

  <div class="container" v-cloak>
    <div class="main-in">
      <div is='titlebox' :nav='JSON.parse(nav)'></div>
      <div class="content">

        <div class="min-h">
          <div class="f-row-l align-start">
            <div class="navbox mt22">
              <div class="defbtn" :class="ind==act?'brief':''" v-for='(item,ind) in brief2' :key="ind"
                   @click="btn(item,ind)">{{ item.label }}
              </div>
            </div>
            <div :class="brief2.length>0?'words-r':'w-100'">
              <div>
                <ul v-for="(item, i) in material" :key="i"
                    :title="item.title?item.title:''||item.pictureTitle?item.pictureTitle:''">
                  <li @click="Xx(item)" class="pinter overf-elli pr act-h">
                    <div class="triangle"></div>
                    {{ item.title ? item.title : '' || item.pictureTitle ? item.pictureTitle : '' }}
                    <span>{{ item.createTime ? item.createTime : '' }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="param.pageNo"
              :page-size="param.pageSize"
              layout="prev, pager, next, jumper"
              :total="param.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  -->
  </div>

</template>
<script>
import {lists} from '@/axios/api';
import workNews from '@/views/news/workNews.vue';
import partyService from '@/views/news/partyService.vue';
import focusYouth from '@/views/news/focusYouth.vue';
import youthVolunteer from '@/views/news/youthVolunteer.vue';
import fileInfo from '@/views/news/fileInfo.vue';

export default {
  components: {workNews, partyService, focusYouth, youthVolunteer, fileInfo},
  computed: {
    nav: function () {
      var tier=2;

      if(this.type == '0'){
        this.title = '热点新闻';
      }else{
        this.$axios.get(this.$apiUrlZY+'api/infocolumn/volInfoColumn/rootList').then(res=>{
          if(res.success){
            let newsTypeList=res.result;
            for(var i= 0 ;i < newsTypeList.length;i++){
              if(this.type == (i+1)){
                this.title = newsTypeList[i].name;
              }
            }
          }
        })
      }
      var arr=this.$util.getTopNavZyz(this.title, this.$route.query.type,tier)
      return JSON.stringify(arr)
    }
  },
  data() {
    return {
      newsTypeList:[],

      material: [],
      personList: [],
      brief2: [],
      act: 0,
      type: this.$route.query.type || '0',
      title: '',
      param: {
        pageNo: 1,//分页
        pageSize: 10,
        total: 0,
      }
    }
  },
  mounted() {
    this.getType();
  },
  watch: {
    $route(to, from, next) {
      if (to.path.indexOf('/news') != -1) {
        this.type = this.$route.query.type;
        this.param.pageNo = 1
        this.getZYList();
      }
    },
  },
  methods: {
    getType(){
      if(this.type == '0'){
        this.getZYList(0)
      }else{
        this.$axios.get(this.$apiUrlZY+'api/infocolumn/volInfoColumn/rootList').then(res=>{
          if(res.success){
            this.newsTypeList=res.result;
            for(var i= 0 ;i < this.newsTypeList.length;i++){
              if(this.type == (i+1)){
                this.title = this.newsTypeList[i].name;
                this.getZYList(this.newsTypeList[i].id)
              }
            }
          }
        })
      }
    },
    btn(item, ind) {
      this.act = ind
      this.type = item.slotTitle
      this.title = this.$util.getTitle(this.type)
      this.$router.push({path: '/news', query: {type: this.type}});

    },

    handleSizeChange(val) {
      this.$util.goTop()
      // console.log(`每页 ${val} 条`);
      this.param.pageSize = val;
      this.getZYList();
    },
    handleCurrentChange(val) {
      this.$util.goTop()
      // console.log(`当前页: ${val}`);
      this.param.pageNo = val;
      this.getZYList();
    },
    getZYList() {//志愿者项目接口
      this.material = []
      this.$axios.get(this.$apiUrlZY + `api/external/rootList?businessId=${this.type}&pageNo=${this.param.pageNo}&pageSize=${this.param.pageSize}`).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    Xx(item) {
      this.$util.goTop()
      this.$router.push(`/newVolDetail?type=${this.type}&id=${item.id}`);
    },
  },


}
</script>
<style lang="scss" scoped>
.headbox {
  // background: #F1F1F1;
  width: 80px;
  height: 112px;
  overflow: hidden;
  margin-right: 10px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.txt {
  width: calc(100% - 90px);

  .font-w {
    font-weight: 600;
    margin-bottom: 10px;
  }
}

.content {
  width: calc(100% - 100px);
  margin: auto;

  ul {
    width: 100%;

    .pr {
      padding-right: 180px;
    }

    li {
      width: 100%;
      list-style: none;
      text-align: left;
      display: inline-block;
      line-height: 25px;
      padding-bottom: 15px;
      border-bottom: 1px dashed #E0E0E0;
      font-size: 16px;
      font-weight: 400;
      color: #333333;

      position: relative;

      span {
        font-size: 14px;
        color: #999999;
        position: absolute;
        right: 20px;
        font-weight: 100;
      }
    }
  }

  .block {
    text-align: center;
    line-height: 50px;
    margin-top: 20px;
  }

  .defbtn, .brief {
    margin-top: 0;
  }
}
</style>
